import React, { useState } from "react";
import { Modal as AntModal, Button, message } from "antd";
import styled from "styled-components";
import api from "../../../../api/api";
import { IconBlockLight, IconUnblockLight } from "../../../../assets/icons";
import { useTranslation } from "react-i18next";

const Modal = styled(AntModal)`
  .ant-modal-title {
    font-size: 24px;
  }
`;

const Footer = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;

  .ant-btn {
    flex: 1;
  }

  .ant-btn-default {
    height: 56px;
  }

  .ant-btn-primary {
    height: 56px;
    background: ${(props) => (props.status ? "#F00" : "#009800")};

    :hover {
      background: ${(props) => (props.status ? "#F00" : "#009800")} !important;
    }
  }
`;

const ConfirmModal = ({ open, id, status, handleClose, successCallback }) => {
  const [loading, setLoading] = useState(false);

  const {t} = useTranslation();

  const updateStatus = () => {
    if (!loading) {
      setLoading(true);
      api
        .updateUserStatus(id)
        .then(() => {
          setLoading(false);
          message.success(
            `${status ? t('blocked') : t('unblocked')} ${t('successfully')}`
          );
          handleClose();
          successCallback();
        })
        .catch((error) => {
          setLoading(false);
          message.error(error);
        });
    }
  };

  const onCancel = () => {
    !loading && handleClose();
  };

  return (
    <Modal
      centered
      width={500}
      title={`${status ? t('block') : t('unblock')} ${t('customer')}?`}
      open={open}
      confirmLoading={loading}
      onCancel={onCancel}
      onOk={updateStatus}
      footer={
        <Footer status={status}>
          <Button type="default" onClick={onCancel}>
            {t('cancel')}
          </Button>
          <Button
            type="primary"
            loading={loading}
            icon={status ? <IconBlockLight /> : <IconUnblockLight />}
            onClick={updateStatus}
          >
            {status ? t('block') : t('unblock')}
          </Button>
        </Footer>
      }
    >
      {t('block_sure')}
    </Modal>
  );
};

export default ConfirmModal;
